import { render, staticRenderFns } from "./OrderHistoryLink.vue?vue&type=template&id=c9a893a6&scoped=true"
import script from "./OrderHistoryLink.vue?vue&type=script&lang=js"
export * from "./OrderHistoryLink.vue?vue&type=script&lang=js"
import style0 from "./OrderHistoryLink.vue?vue&type=style&index=0&id=c9a893a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a893a6",
  null
  
)

export default component.exports